import DatePicker, { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import { DATA_START_DATE } from "../../settings/settings";

registerLocale("es", es);

/** Wrapper de react-datepicker que toma value como string ISO YYYY-MM-DD
 * y emite el mismo formato al onChange. Esconde la inconsistencia
 * Date/string del resto de la app. */
export default function DateField({
  value,
  onChange,
  min,           // YYYY-MM-DD inclusive
  max,           // YYYY-MM-DD inclusive
  excludeDates,  // array de YYYY-MM-DD a deshabilitar
  placeholder,
  accent,        // "yellow" | "blue"
  size = "default",
}) {
  const dateValue = value ? new Date(`${value}T12:00:00`) : null;
  // Piso duro: nunca antes de DATA_START_DATE, sin importar el `min` del caller.
  const effMin = min && min > DATA_START_DATE ? min : DATA_START_DATE;
  const minDate = new Date(`${effMin}T12:00:00`);
  const maxDate = max ? new Date(`${max}T12:00:00`) : undefined;
  const excluded = (excludeDates || []).map((d) => new Date(`${d}T12:00:00`));

  return (
    <div className={`date-field date-field--${accent || "yellow"} date-field--${size}`}>
      <DatePicker
        selected={dateValue}
        onChange={(d) => {
          if (!d) return onChange(null);
          // No usar toISOString() — convierte a UTC y para navegadores al
          // este del meridiano puede retroceder un día. El picker entrega
          // un Date construido en hora local, así que extraemos los
          // componentes locales directamente.
          const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
          onChange(iso);
        }}
        dateFormat="dd MMM yyyy"
        locale="es"
        minDate={minDate}
        maxDate={maxDate}
        excludeDates={excluded}
        placeholderText={placeholder || "Elegí una fecha"}
        showPopperArrow={false}
        popperPlacement="bottom-start"
        calendarStartDay={1}     // lunes primero
      />
    </div>
  );
}
